import { useState } from "react";
import { api, apiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PrezzoConvenzionato } from "@/components/accordi/PrezzoConvenzionato";
import { toast } from "sonner";
import { Loader2, Check } from "lucide-react";

const NUCLEI = [["single", "Single"], ["partner", "Coppia"], ["nucleo_parziale", "Un adulto e figli"], ["nucleo_intero", "Due genitori e figli"]];

// Protezione Famiglia: confronto delle soluzioni per il nucleo scelto, con premio convenzionato.
export const CalcPf = ({ codice, onSalva }) => {
  const [nucleo, setNucleo] = useState("single");
  const [res, setRes] = useState(null);
  const [scelta, setScelta] = useState(null);
  const [busy, setBusy] = useState(false);

  const calcola = async (n = nucleo) => {
    setBusy(true);
    try {
      const { data } = await api.post("/public/accordi/calcola", { codice, product: "formula_self", input: { nucleo: n } });
      if (!data.ok) throw new Error(data.errore);
      setRes(data); setScelta(data.soluzioni[1]?.code || data.soluzioni[0]?.code);
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-4" data-testid="calc-pf">
      <div className="space-y-1.5">
        <Label>Chi vuoi proteggere?</Label>
        <div className="flex flex-wrap gap-2">
          {NUCLEI.map(([v, l]) => (
            <button key={v} onClick={() => { setNucleo(v); calcola(v); }} data-testid={`pf-nucleo-${v}`}
              className={`rounded-full border px-3.5 py-1.5 text-sm transition-colors ${nucleo === v ? "border-forest bg-forest text-white" : "border-border text-forest hover:bg-sage"}`}>{l}</button>
          ))}
        </div>
      </div>
      {!res && <Button onClick={() => calcola()} disabled={busy} data-testid="pf-calcola" className="bg-forest hover:bg-forest-hover">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Confronta le soluzioni</Button>}
      {res && (
        <div className="grid gap-3 md:grid-cols-3" data-testid="pf-soluzioni">
          {res.soluzioni.map((s) => (
            <button key={s.code} onClick={() => setScelta(s.code)} data-testid={`pf-soluzione-${s.code}`}
              className={`space-y-3 rounded-2xl border-2 bg-white p-4 text-left transition-all ${scelta === s.code ? "border-terracotta shadow-md" : "border-border/60 hover:border-forest/40"}`}>
              <div className="flex items-center justify-between">
                <span className="font-heading text-lg font-semibold text-forest">{s.nome}</span>
                {scelta === s.code && <Check className="h-5 w-5 text-terracotta" />}
              </div>
              <p className="text-xs text-muted-foreground">{s.descrizione}</p>
              <PrezzoConvenzionato r={s} testid={`pf-prezzo-${s.code}`} />
            </button>
          ))}
        </div>
      )}
      {res && <Button onClick={() => onSalva({ nucleo, pacchetto: scelta })} disabled={!scelta} data-testid="pf-salva" className="bg-terracotta hover:bg-terracotta-hover">Salva la soluzione scelta</Button>}
    </div>
  );
};
